var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ok-circle_2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,11.75c-6.755,0-12.25,5.495-12.25,12.25S17.245,36.25,24,36.25c6.755,0,12.25-5.495,12.25-12.25S30.755,11.75,24,11.75 z M24,33c-4.963,0-9-4.037-9-9s4.037-9,9-9c4.963,0,9,4.037,9,9S28.963,33,24,33z M30.06,21.987l-7.512,7.511 c-0.127,0.128-0.337,0.128-0.465,0l-2.132-2.133c-0.128-0.128-0.338-0.337-0.465-0.465l-1.567-1.567 c-0.128-0.127-0.128-0.336,0-0.465l2.134-2.133c0.128-0.128,0.337-0.128,0.464,0l1.567,1.567c0.128,0.127,0.337,0.127,0.465,0 l4.895-4.895c0.127-0.128,0.337-0.129,0.467-0.002l2.146,2.118C30.187,21.651,30.187,21.859,30.06,21.987z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkCircle);
export default __webpack_public_path__ + "static/media/ok-circle.f6b959c6.svg";
export { ForwardRef as ReactComponent };